import { render, staticRenderFns } from "./WidgetWallet.vue?vue&type=template&id=0b265ff0"
import script from "./WidgetWallet.vue?vue&type=script&lang=js"
export * from "./WidgetWallet.vue?vue&type=script&lang=js"
import style0 from "./WidgetWallet.vue?vue&type=style&index=0&id=0b265ff0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports